__turbopack_context__.v({
  "icon": "ListItemLeading-module-scss-module__oN8QcW__icon",
  "number": "ListItemLeading-module-scss-module__oN8QcW__number",
  "p-font-serif": "ListItemLeading-module-scss-module__oN8QcW__p-font-serif",
  "p-serif": "ListItemLeading-module-scss-module__oN8QcW__p-serif",
  "ql-editor": "ListItemLeading-module-scss-module__oN8QcW__ql-editor",
  "ql-snow": "ListItemLeading-module-scss-module__oN8QcW__ql-snow",
  "u-typography-body": "ListItemLeading-module-scss-module__oN8QcW__u-typography-body",
  "u-typography-h1": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h1",
  "u-typography-h2": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h2",
  "u-typography-h3": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h3",
  "u-typography-h4": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h4",
  "u-typography-h5": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h5",
  "u-typography-h6": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h6",
  "u-typography-h7": "ListItemLeading-module-scss-module__oN8QcW__u-typography-h7",
});
